import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {BirthdaysModule} from './birthdays/birthdays.module';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {AppComponent} from './app.component';
import {LayoutLoggedInComponent} from './layout-logged-in/layout-logged-in.component';
import {LayoutNotLoggedInComponent} from './layout-not-logged-in/layout-not-logged-in.component';
import {MenuComponent} from './menu/menu.component';
import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {HomeComponent} from './home/home.component';
import {loginRoutes} from './login/login.routes';
import {AuthguardService} from './authguard.service';
import {AuthenticationService} from './authentication.service';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {MessageService} from './message.service';
import {ApiService} from './api.service';
import {MenuService} from './menu/menu.service';
import {LinksModule} from './links/links.module';
import {FilesModule} from './files/files.module';
import {LogoutComponent} from './logout/logout.component';
import {SharedModule} from './shared/shared.module';
import {NotesModule} from './notes/notes.module';
import {CalendarModule} from './calendar/calendar.module';
import {DashboardComponent} from './dashboard/dashboard.component';
import {SearchModule} from './search/search.module';
import {AccountModule} from './account/account.module';
import { DashboarditemComponent } from './dashboard/dashboarditem/dashboarditem.component';

const routes: Routes = [
    {
        path: '',
        component: DashboardComponent,
        canActivate: [AuthguardService], // comment out for testing during development
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthguardService]
    },
    ...loginRoutes
];

const routing: ModuleWithProviders = RouterModule.forRoot(routes);

@NgModule({
    declarations: [
        AppComponent,
        LayoutLoggedInComponent,
        LayoutNotLoggedInComponent,
        MenuComponent,
        LoginComponent,
        HomeComponent,
        LogoutComponent,
        DashboardComponent,
        DashboarditemComponent
    ],
    imports: [
        MatSnackBarModule,
        RouterModule,
        BrowserModule,
        BirthdaysModule,
        LinksModule,
        FormsModule,
        FilesModule,
        HttpClientModule,
        SharedModule,
        NotesModule,
        CalendarModule,
        SearchModule,
        AccountModule,
        routing
    ],
    exports: [
        RouterModule,
        SharedModule
    ],
    providers: [AuthguardService, AuthenticationService, MessageService, ApiService, MenuService],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts